const types = {
  //Get Template name
  GET_SERVICES_START: "GET_SERVICES_START",
  GET_SERVICES_SUCCESS: "GET_SERVICES_SUCCESS",
  GET_SERVICES_ERROR: "GET_SERVICES_ERROR",
  GET_SERVICES_RESET: "GET_SERVICES_RESET",

  //Create Template name
  CREATE_SERVICES_START: "CREATE_SERVICES_START",
  CREATE_SERVICES_SUCCESS: "CREATE_SERVICES_SUCCESS",
  CREATE_SERVICES_ERROR: "CREATE_SERVICES_ERROR",
  CREATE_SERVICES_RESET: "CREATE_SERVICES_RESET",

  //delete Template name
  DELETE_SERVICES_START: "DELETE_SERVICES_START",
  DELETE_SERVICES_SUCCESS: "DELETE_SERVICES_SUCCESS",
  DELETE_SERVICES_ERROR: "DELETE_SERVICES_ERROR",
  DELETE_SERVICES_RESET: "DELETE_SERVICES_RESET",

  //update Template name
  UPDATE_SERVICES_START: "UPDATE_SERVICES_START",
  UPDATE_SERVICES_SUCCESS: "UPDATE_SERVICES_SUCCESS",
  UPDATE_SERVICES_ERROR: "UPDATE_SERVICES_ERROR",
  UPDATE_SERVICES_RESET: "UPDATE_SERVICES_RESET",

  //single item  name
  SINGLE_SERVICES_START: "SINGLE_SERVICES_START",
  SINGLE_SERVICES_SUCCESS: "SINGLE_SERVICES_SUCCESS",
  SINGLE_SERVICES_ERROR: "SINGLE_SERVICES_ERROR",
  SINGLE_SERVICES_RESET: "SINGLE_SERVICES_RESET",
};

export default types;
